import BuildIcon from '@/components/Theme03/Icons/BuildIcon'
import HouseIcon from '@/components/Theme03/Icons/HouseIcon'
import OfficeIcon from '@/components/Theme03/Icons/OfficeIcon'
import MapIcon from '@/components/Theme03/Icons/MapIcon'
import StoreIcon from '@/components/Theme03/Icons/StoreIcon'
import CoconutIcon from '@/components/Theme03/Icons/CoconutIcon'
import CartIcon01 from '@/components/Theme01/Icons/CartIcon01'
import CartShopIcon01 from '@/components/Theme01/Icons/CartShopIcon01'
import BagIcon from '@/components/Theme01/Icons/BagIcon'
import BuildIcon2 from '@/components/Theme03/Icons/BuildIcon2'
import BuildIcon3 from '@/components/Theme03/Icons/BuildIcon3'
import BuildIcon4 from '@/components/Theme03/Icons/BuildIcon4'
import BuildfixIcon from '@/components/Theme03/Icons/BuildfixIcon'
import BuildcraftIcon from '@/components/Theme03/Icons/BuildcraftIcon'
import BuildIcon5 from '@/components/Theme03/Icons/BuildIcon5'
import BuildhomeIcon from '@/components/Theme03/Icons/BuildhomeIcon'
import BuildIcon6 from '@/components/Theme03/Icons/BuildIcon6'
import BeschIcon from '@/components/Theme03/Icons/BeachIcon'

export const icons = {
  BuildIcon,
  HouseIcon,
  OfficeIcon,
  MapIcon,
  StoreIcon,
  CoconutIcon,
  CartIcon01,
  CartShopIcon01,
  BagIcon,
  BuildIcon2,
  BuildIcon3,
  BuildIcon4,
  BuildfixIcon,
  BuildcraftIcon,
  BuildIcon5,
  BuildhomeIcon,
  BuildIcon6,
  BeschIcon
}
